import { PayloadAction, SliceCaseReducers, ValidateSliceCaseReducers } from '@reduxjs/toolkit';

import { RestfulModel } from 'app/model/restful-model';

import { SliceState } from './slice-state';

export const reducers: ValidateSliceCaseReducers<SliceState, SliceCaseReducers<SliceState>> = {
    /**
     * Sets the currently resolved model by this service.
     *
     * Mostly for CRUD where we typically have single resolved model being updated in a form.
     *
     * @param state
     * @param action
     */
    setResolvedValue: (state, action: PayloadAction<{ data: RestfulModel<number | string>; name: string }>) => {
        state.resolvedMap[action.payload.name] = action.payload.data;
    },

    /**
     * Clear the cached model to force reload from server.
     *
     * @param state
     * @param action
     */
    clearResolvedValue: (state, action: PayloadAction<string>) => {
        state.resolvedMap[action.payload] = undefined;
    },
};
